<template>
  <div class="dashboard-grid">
      <div :class="'dashboard-card '+ getStatus(problems.project, problems.project.errors)" @click="problems.project.open=true; scrollToSection(problems.project.id)">
        <div class="card-title">{{ problems.project.name }} <strong>Всего: {{ problems.project.count }}</strong></div>
        <div class="card-value table">
          <div class="row head">
            <div class="col">готово</div>
            <div class="col">ошибок</div>
            <div class="col">всего</div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col">{{problems.project.data.filter(x=>x.ready).length}}</div>
            <div class="col">{{ problems.project.errors }}</div>
            <div class="col">{{problems.project.data.length}}</div>
            <div class="col"></div>
          </div>
        </div>
        <div class="card-subtitle">{{ problems.project.description }}</div>
        <div class="card-icon"><i :class="'bi '+ problems.project.ico"></i></div>
      </div>
    <template v-for="(problem, key) in problems">
      <div v-if="!problem.is_hide" :class="'dashboard-card '+ getStatus(problem, problem.count)" @click="problem.open=true; scrollToSection(problem.id)">
        <div class="card-title">{{ problem.name }}</div>
        <div class="card-value">{{ problem.count }}</div>
        <div class="card-subtitle">{{ problem.description }}</div>
        <div class="card-icon"><i :class="'bi '+ problem.ico"></i></div>
      </div>
    </template>

  </div>

</template>

<script>

export default {
  name: 'ProblemCards',
  data() {
    return {}
  },
  props: {
    problems: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    getStatus(problem, count){
      let status = "info";
      if (problem.nonzero){
        status = count > 0?"success":"critical"
      }
      else{
        status = count <= 0?"success":count<2?"info":count<20?"warning":"critical";
      }
      return status
    },
    scrollToSection(sectionId) {
            const section = document.getElementById(sectionId);
      // if (section) {
      //   const header = section.querySelector('.accordion-header');
      //   const content = section.querySelector('.accordion-content');
      //
      //   if (!content.classList.contains('active')) {
      //     header.classList.add('active');
      //     content.classList.add('active');
      //   }

        section.scrollIntoView({behavior: 'smooth', block: 'start'});

        section.style.boxShadow = '0 0 0 3px #3498db';
        setTimeout(() => {
          section.style.boxShadow = '';
        }, 1500);

    },

  }
}
</script>

<style scoped lang="scss">
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  .dashboard-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #e9ecef;
    position: relative;
    overflow: hidden;

    &:hover {

      transform: translateY(-4px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    }

    &.critical {
      border-left: 4px solid #e74c3c;
    }

    &.warning {
      border-left: 4px solid #f39c12;
    }

    &.success {
      border-left: 4px solid #27ae60;
    }

    &.info {
      border-left: 4px solid #3498db;
    }

    .card-title {
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: #7f8c8d;
      margin-bottom: 10px;
    }

    .card-value {
      font-size: 42px;
      font-weight: bold;
      color: #2c3e50;
      line-height: 1;
      margin-bottom: 8px;
      &.table{
        display: flex;
        flex-direction: column;
        .row{
          &.head{
            font-size: 10px;
          }
        }
      }
    }

    .card-subtitle {
      font-size: 12px;
      color: #95a5a6;
    }

    .card-icon {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 38px;
      opacity: 0.3;
    }

  }
}
</style>